import { getCallable } from "../../../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import type {
    UpdatePaymentMethodRequest,
    UpdatePaymentMethodResponse
} from "./types";

export { apiName };

const updatePaymentMethod = getCallable<UpdatePaymentMethodRequest, UpdatePaymentMethodResponse>(
    apiName,
    "updatePaymentMethod",
    {
        ...endpoints.updatePaymentMethod,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/billing/payment-method`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    });

export const callables = {
    updatePaymentMethod
};
